import { render, staticRenderFns } from "./FormPassword.vue?vue&type=template&id=b08cd29e&scoped=true&"
import script from "./FormPassword.vue?vue&type=script&lang=js&"
export * from "./FormPassword.vue?vue&type=script&lang=js&"
import style0 from "./FormPassword.vue?vue&type=style&index=0&id=b08cd29e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08cd29e",
  null
  
)

export default component.exports